module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('header-bar', {
    attrs: {
      "title": _vm.$t('dashboard.titulos.portlet'),
      "subTitle": _vm.$t('dashboard.titulos.portlet')
    }
  }, [_c('div', {
    attrs: {
      "slot": "fields"
    },
    slot: "fields"
  }, [_c('v-select', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    staticClass: "style-chooser",
    class: {
      'input': true,
      'is-danger': _vm.errors.has('filter.periodType')
    },
    attrs: {
      "options": _vm.periodList,
      "clearable": false,
      "id": "periodType",
      "name": "periodType",
      "value": "id"
    },
    on: {
      "input": _vm.onPeriodChanged
    },
    model: {
      value: (_vm.filter.periodType),
      callback: function($$v) {
        _vm.$set(_vm.filter, "periodType", $$v)
      },
      expression: "filter.periodType"
    }
  }, [_c('span', {
    attrs: {
      "slot": "no-options"
    },
    domProps: {
      "innerHTML": _vm._s(_vm.$t('estabelecimentos.labels.nenhumResultado'))
    },
    slot: "no-options"
  })]), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('filter.periodType')),
      expression: "errors.has('filter.periodType')"
    }],
    staticClass: "help is-danger",
    domProps: {
      "innerHTML": _vm._s(_vm.$t('validacao.campoObrigatorio'))
    }
  }), _c('date-range', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showDateRange()),
      expression: "showDateRange()"
    }],
    ref: "dateRange",
    staticClass: "col-xs-6 col-sm-6 col-md-6 col-lg-6 px-0",
    attrs: {
      "initialFromDate": _vm.firstDate,
      "initialToDate": _vm.finalDate,
      "maxRange": 31,
      "finalDateDisableFrom": _vm.finalDateDisable,
      "displayLabel": false,
      "displayAction": true,
      "action": _vm.setCustomRangeFilter
    },
    model: {
      value: (_vm.dateRange),
      callback: function($$v) {
        _vm.dateRange = $$v
      },
      expression: "dateRange"
    }
  })], 1)]), _c('br'), _c('draggable', {
    attrs: {
      "list": _vm.charts,
      "handle": ".dashboard-top"
    },
    on: {
      "end": _vm.saveDashboard
    }
  }, _vm._l((_vm.charts), function(chart, index) {
    return _c('chart', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (_vm.configChartShow(chart)),
        expression: "configChartShow(chart)"
      }],
      key: chart.idChartTemplate + chart.container,
      staticClass: "chart-item",
      class: chart.container === "chartFull" ? "col-md-12" : "col-md-6",
      attrs: {
        "chart": chart,
        "id": chart.idChart,
        "showTaskGadget": chart.showTaskGadget
      },
      on: {
        "onResize": function($event) {
          return _vm.resize(index, chart)
        }
      }
    })
  }), 1)], 1)
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-632aab56", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-632aab56"}!./~/vue-loader/lib/template-compiler/preprocessor.js?raw&engine=pug!./client/components/dashboard/dashboard.pug
// module id = 1421
// module chunks = 0